
// export const environment = {
//     production: true,
//     apiBaseUrl: "https://portalapi.credsure.redianglobal.com",
//     ImageBaseUrl: "https://adminapi.credsure.redianglobal.com",
//     frontEndBaseUrl: "https://portalapi.credsure.redianglobal.com",
//     frontEndUrl: "https://portalapi.credsure.redianglobal.com",
//     Currency: 'KES',
//     enc_key: '1234567890123456',
//     VehicleDropDownStartYear: 1971,
//     googleAutoCompleteApi: 'AIzaSyDtpifMidVYOOPShcG1eEWOIlQ3YVAhN6Q',
//     mapAPIKey: 'AIzaSyDtpifMidVYOOPShcG1eEWOIlQ3YVAhN6Q',
//   };


export const environment = {
  production: true,
  apiBaseUrl: "https://bloom-cust-api.redianglobal.com",
  ImageBaseUrl: "https://atom-admin.api.redianglobal.com/",
  frontEndBaseUrl: "https://bloom-cust-api.redianglobal.com",
  frontEndUrl: "https://bloom-cust-api.redianglobal.com",
  Currency: 'KES',
  enc_key: '1234567890123456',
  VehicleDropDownStartYear: 1971,
  googleAutoCompleteApi: 'AIzaSyDtpifMidVYOOPShcG1eEWOIlQ3YVAhN6Q',
  mapAPIKey: 'AIzaSyDtpifMidVYOOPShcG1eEWOIlQ3YVAhN6Q',
};



